//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            mode: null
        };
    },


    methods: {
        setMode: function setMode(mode) {
            this.mode = mode;
        },
        login: function login() {
            App.event.fire('login.send');
        },
        register: function register() {
            App.event.fire('registration.send');
        },
        guest: function guest() {
            App.event.fire('guest.send');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/user-handler/components/UserHandler.vue
// module id = wafT
// module chunks = 4